import fetchBeneficiaryAccess from '@Application/Beneficiaries/Access/fetchBeneficiaryAccess';
import FetchBeneficiaryAccess from '@Application/Beneficiaries/Access/Queries/FetchBeneficiaryAccess';
import useAuthenticatedUser from '@UI/Providers/AuthenticatedUserProvider/useAuthenticatedUser';
import type BeneficiaryAccessView from '@UI/Store/BeneficiaryAccess/Views/BeneficiaryAccessView';
import { useDispatch, useStoreQuery } from '@verclam/synapse';

export type UseBeneficiaryAccessResult = {
	access: BeneficiaryAccessView | null;
	isLoading: boolean;
	error: Error | null;
};

/**
 * Loads the caller's level on the beneficiary dossier type. The store drops it when the type grants
 * are saved, which makes this hook re-fetch.
 */
function useBeneficiaryAccess(): UseBeneficiaryAccessResult {
	const dispatch = useDispatch();
	const { user } = useAuthenticatedUser();
	const accountId = user?.account?.id ?? null;

	const {
		data: access,
		isLoading,
		error,
	} = useStoreQuery({
		selector: (state) => state.beneficiaryAccessStore.access,
		stopOn: (value) => accountId === null || (value !== null && value.accountId === accountId),
		query: () => {
			if (accountId === null) {
				return Promise.resolve();
			}

			return dispatch(fetchBeneficiaryAccess(new FetchBeneficiaryAccess(accountId)));
		},
		deps: [accountId],
	});

	return { access, isLoading, error };
}

export default useBeneficiaryAccess;
